import { lazy, Suspense } from "react";
import MesonetClimateLayout from "../../component/MesonetClimateLayout";
import { Box, CircularProgress } from "@mui/material";

const StatsContent = lazy(() => import("../../component/StatsContent"));

export default function MesonetClimateStats() {
    return (
        <MesonetClimateLayout activeTab={1}>
            <Suspense
                fallback={
                    <Box sx={{ display: "flex", justifyContent: "center", p: 5 }}>
                        <CircularProgress />
                    </Box>
                }
            >
                <StatsContent />
            </Suspense>
        </MesonetClimateLayout>
    );
}
